import React from 'react';
import { observer } from 'mobx-react-lite';
import decline from 'utils/decline';

const Year = observer(({ year, isPurchase, before = '' }) => {
  const truckAge = () => {
    const date = new Date();
    return date.getFullYear() - year;
  };

  if (!year) return null;

  return (
    <tr>
      <td className="pale">Год</td>
      <td>
        <span className="bold">
          {before}
          {year}
        </span>
        {!isPurchase && (
          <span className="transparent">
            {` (${truckAge()} ${decline(truckAge(), ['год', 'года', 'лет'])})`}
          </span>
        )}
      </td>
    </tr>
  );
});

export default Year;
